import { ColorPicker, Tooltip } from 'antd';
import getColorName from 'utils/getColorName';

const BackgroundColorPicker = ({ value, onChange }) => {
  return (
    <div className="flex gap-2 items-center">
      <span className="flex items-center gap-2">
        <ColorPicker
          value={value}
          onChange={(color) => onChange(color.toHexString())}
          allowClear={true}
        />
        {value && (
          <span className="text-[#555]">
            <Tooltip title={value.toUpperCase()}>
              {getColorName(value)}
            </Tooltip>
          </span>
        )}
      </span>
    </div>
  );
};

export default BackgroundColorPicker;

